export const volumeRebateEn = {
  VOLUME_REBATE: 'Volume Rebate',
  ENABLE_VOLUME_REBATE: 'Enable Volume Rebate',
  VOLUME_REBATE_TIERS: 'Tiers',
  VOLUME_REBATE_STARTING_INVOICE_AMOUNT: 'Starting Invoice Amount',
  VOLUME_REBATE_FEE_REBATE: 'Fee Rebate',
  ADD_VOLUME_REBATE_TIER: 'Add Tier',
  CLEAR_ALL_VOLUME_REBATE_TIERS: 'Clear All',
  VOLUME_REBATE_CLEAR_ALL_CONFIRMATION: 'Are you sure you want to clear all volume rebate tiers?',
  VOLUME_REBATE_TIERS_KEPT_WHEN_DISABLED: 'Tiers are kept while Volume Rebate is disabled.',
  VOLUME_REBATE_MAX_TIERS_REACHED: 'A maximum of {0} tiers is allowed.',
  VOLUME_REBATE_START_AMOUNT_MUST_INCREASE: 'Must be greater than the previous tier starting invoice amount',
  VOLUME_REBATE_FEE_REBATE_MUST_INCREASE: 'Must be greater than the previous tier fee rebate',
  VOLUME_REBATE_FEE_REBATE_RANGE: 'Must be between 0% and 100%',
  VOLUME_REBATE_START_AMOUNT_NOT_NEGATIVE: 'Must be greater than or equal to $0',
  VOLUME_REBATES: 'Volume Rebates',
  VOLUME_REBATE_SEARCH_PLACEHOLDER: 'Search by company name',
  VOLUME_REBATE_PERIOD: 'Period',
  VOLUME_REBATE_REBATES_COUNT: '{0} rebates',
  VOLUME_REBATE_PURCHASE_VOLUME: 'Purchase Volume',
  VOLUME_REBATE_CHARGEBACKS: 'Chargebacks',
  VOLUME_REBATE_TIER: 'Tier',
  VOLUME_REBATE_TIER_NUMBER: 'Tier {0}',
  VOLUME_REBATE_PURCHASE_FEES: 'Purchase Fees',
  VOLUME_REBATE_CALCULATED_REBATE: 'Calc. Rebate',
  VOLUME_REBATE_ADJUSTED_REBATE: 'Adjusted Rebate',
  VOLUME_REBATE_ADJUSTED: 'Adjusted',
  VOLUME_REBATE_ADJUSTED_BY: 'Adjusted by {0} on {1}',
  VOLUME_REBATE_REMOVE_ADJUSTMENT: 'Remove adjustment',
  VOLUME_REBATE_DISPUTED: 'Disputed',
  VOLUME_REBATE_STATUS: 'Status',
  VOLUME_REBATE_APPROVE: 'Approve',
  VOLUME_REBATE_ALL: 'All',
  VOLUME_REBATE_REVIEWED_BY: 'Reviewed By',
  VOLUME_REBATE_PERIOD_TOTALS: 'Period Totals',
  VOLUME_REBATE_TIER_SCHEDULE: 'Tier Schedule',
  VOLUME_REBATE_VOLUME_FROM: 'Volume From',
  VOLUME_REBATE_VOLUME_TO: 'Volume To',
  VOLUME_REBATE_REBATE_PERCENT: 'Rebate %',
  VOLUME_REBATE_CALCULATION: 'Calculation',
  VOLUME_REBATE_QUALIFYING_PERIOD: 'Qualifying Period',
  VOLUME_REBATE_INVOICES_PURCHASED: 'Invoices Purchased',
  VOLUME_REBATE_VIEW_INVOICES: 'View {0} invoices',
  VOLUME_REBATE_LESS_CHARGEBACKS: 'Less Chargebacks',
  VOLUME_REBATE_DISPUTED_EXCLUDED: 'Disputed AR (excluded)',
  VOLUME_REBATE_NET_VOLUME: 'Net Volume (tier basis)',
  VOLUME_REBATE_PURCHASE_FEES_CHARGED: 'Purchase Fees Charged',
  VOLUME_REBATE_TIER_RATE: 'Tier Rate',
  VOLUME_REBATE_REBATE: 'Rebate',
  VOLUME_REBATE_LEDGER_PREVIEW: 'Ledger Preview (on approval)',
  VOLUME_REBATE_LEDGER_FEE: 'Fee',
  VOLUME_REBATE_LEDGER_CASH_RESERVE: 'Cash Reserve',
  VOLUME_REBATE_LEDGER_GL_CODE: 'GL {0}',
  VOLUME_REBATE_LEDGER_NOT_POSTED: 'No ledger entries are posted until this rebate is approved.',
  VOLUME_REBATE_LEDGER_DENIED: 'Not posted: this rebate was denied.',
  VOLUME_REBATE_SNAPSHOT_DISCLAIMER:
    'The tier schedule and the invoices purchased were taken when the request was created ({0}); the current ones may differ.',
  VOLUME_REBATE_APPROVE_SELECTED: 'Approve Selected',
  VOLUME_REBATE_REJECT_SELECTED: 'Reject Selected',
  VOLUME_REBATE_SELECTED_COUNT: '{0} selected',
  VOLUME_REBATE_SELECTED_TOTAL: '{0} in rebates',
  VOLUME_REBATE_APPROVE_TITLE: 'Approve {0} Volume Rebates',
  VOLUME_REBATE_APPROVE_DISCLAIMER:
    "Approving these requests will post the corresponding Fee and Cash Reserve ledger entries with today's date. This action cannot be undone.",
  VOLUME_REBATE_APPROVE_AND_POST: 'Approve & Post',
  VOLUME_REBATE_DENY_TITLE: 'Deny {0} Volume Rebates',
  VOLUME_REBATE_DENY_CONFIRMATION: 'Denied rebates cannot be approved or edited later. Do you want to continue?',
  VOLUME_REBATE_REVIEWED_SUCCESSFULLY: '{0} volume rebates were reviewed successfully.',
  VOLUME_REBATE_REVIEW_FAILED: '{0} volume rebates could not be reviewed: {1}',
  VOLUME_REBATE_ADJUSTED_SUCCESSFULLY: 'Volume rebate adjusted successfully.',
  VOLUME_REBATE_ADJUSTMENT_NOT_NEGATIVE: 'Must be greater than or equal to $0',
}

export const volumeRebateEs = {
  VOLUME_REBATE: 'Volume Rebate',
  ENABLE_VOLUME_REBATE: 'Habilitar Volume Rebate',
  VOLUME_REBATE_TIERS: 'Tiers',
  VOLUME_REBATE_STARTING_INVOICE_AMOUNT: 'Monto inicial de facturas',
  VOLUME_REBATE_FEE_REBATE: 'Rebate del fee',
  ADD_VOLUME_REBATE_TIER: 'Agregar tier',
  CLEAR_ALL_VOLUME_REBATE_TIERS: 'Limpiar todo',
  VOLUME_REBATE_CLEAR_ALL_CONFIRMATION: '¿Estás seguro de que quieres limpiar todos los tiers de volume rebate?',
  VOLUME_REBATE_TIERS_KEPT_WHEN_DISABLED: 'Los tiers se conservan mientras Volume Rebate esté deshabilitado.',
  VOLUME_REBATE_MAX_TIERS_REACHED: 'Se permite un máximo de {0} tiers.',
  VOLUME_REBATE_START_AMOUNT_MUST_INCREASE: 'Debe ser mayor que el monto inicial del tier anterior',
  VOLUME_REBATE_FEE_REBATE_MUST_INCREASE: 'Debe ser mayor que el rebate del fee del tier anterior',
  VOLUME_REBATE_FEE_REBATE_RANGE: 'Debe estar entre 0% y 100%',
  VOLUME_REBATE_START_AMOUNT_NOT_NEGATIVE: 'Debe ser mayor o igual a $0',
  VOLUME_REBATES: 'Volume Rebates',
  VOLUME_REBATE_SEARCH_PLACEHOLDER: 'Buscar por nombre de compañía',
  VOLUME_REBATE_PERIOD: 'Período',
  VOLUME_REBATE_REBATES_COUNT: '{0} rebates',
  VOLUME_REBATE_PURCHASE_VOLUME: 'Volumen comprado',
  VOLUME_REBATE_CHARGEBACKS: 'Chargebacks',
  VOLUME_REBATE_TIER: 'Tier',
  VOLUME_REBATE_TIER_NUMBER: 'Tier {0}',
  VOLUME_REBATE_PURCHASE_FEES: 'Fees de compra',
  VOLUME_REBATE_CALCULATED_REBATE: 'Rebate calc.',
  VOLUME_REBATE_ADJUSTED_REBATE: 'Rebate ajustado',
  VOLUME_REBATE_ADJUSTED: 'Ajustado',
  VOLUME_REBATE_ADJUSTED_BY: 'Ajustado por {0} el {1}',
  VOLUME_REBATE_REMOVE_ADJUSTMENT: 'Quitar ajuste',
  VOLUME_REBATE_DISPUTED: 'En disputa',
  VOLUME_REBATE_STATUS: 'Estado',
  VOLUME_REBATE_APPROVE: 'Aprobar',
  VOLUME_REBATE_ALL: 'Todos',
  VOLUME_REBATE_REVIEWED_BY: 'Revisado por',
  VOLUME_REBATE_PERIOD_TOTALS: 'Totales del período',
  VOLUME_REBATE_TIER_SCHEDULE: 'Tabla de tiers',
  VOLUME_REBATE_VOLUME_FROM: 'Volumen desde',
  VOLUME_REBATE_VOLUME_TO: 'Volumen hasta',
  VOLUME_REBATE_REBATE_PERCENT: '% de rebate',
  VOLUME_REBATE_CALCULATION: 'Cálculo',
  VOLUME_REBATE_QUALIFYING_PERIOD: 'Período calificado',
  VOLUME_REBATE_INVOICES_PURCHASED: 'Facturas compradas',
  VOLUME_REBATE_VIEW_INVOICES: 'Ver {0} facturas',
  VOLUME_REBATE_LESS_CHARGEBACKS: 'Menos chargebacks',
  VOLUME_REBATE_DISPUTED_EXCLUDED: 'AR en disputa (excluido)',
  VOLUME_REBATE_NET_VOLUME: 'Volumen neto (base del tier)',
  VOLUME_REBATE_PURCHASE_FEES_CHARGED: 'Fees de compra cobrados',
  VOLUME_REBATE_TIER_RATE: 'Tasa del tier',
  VOLUME_REBATE_REBATE: 'Rebate',
  VOLUME_REBATE_LEDGER_PREVIEW: 'Vista previa de ledgers (al aprobar)',
  VOLUME_REBATE_LEDGER_FEE: 'Fee',
  VOLUME_REBATE_LEDGER_CASH_RESERVE: 'Cash Reserve',
  VOLUME_REBATE_LEDGER_GL_CODE: 'GL {0}',
  VOLUME_REBATE_LEDGER_NOT_POSTED: 'No se registran ledgers hasta que se apruebe este rebate.',
  VOLUME_REBATE_LEDGER_DENIED: 'No registrado: este rebate fue rechazado.',
  VOLUME_REBATE_SNAPSHOT_DISCLAIMER:
    'La tabla de tiers y las facturas compradas se tomaron al crear la solicitud ({0}); los valores actuales podrían ser distintos.',
  VOLUME_REBATE_APPROVE_SELECTED: 'Aprobar seleccionados',
  VOLUME_REBATE_REJECT_SELECTED: 'Rechazar seleccionados',
  VOLUME_REBATE_SELECTED_COUNT: '{0} seleccionados',
  VOLUME_REBATE_SELECTED_TOTAL: '{0} en rebates',
  VOLUME_REBATE_APPROVE_TITLE: 'Aprobar {0} volume rebates',
  VOLUME_REBATE_APPROVE_DISCLAIMER:
    'Al aprobar estas solicitudes se registrarán los ledgers de Fee y Cash Reserve correspondientes con la fecha de hoy. Esta acción no se puede deshacer.',
  VOLUME_REBATE_APPROVE_AND_POST: 'Aprobar y registrar',
  VOLUME_REBATE_DENY_TITLE: 'Denegar {0} volume rebates',
  VOLUME_REBATE_DENY_CONFIRMATION: 'Los rebates denegados no se pueden aprobar ni editar después. ¿Quieres continuar?',
  VOLUME_REBATE_REVIEWED_SUCCESSFULLY: '{0} volume rebates se revisaron correctamente.',
  VOLUME_REBATE_REVIEW_FAILED: 'No se pudieron revisar {0} volume rebates: {1}',
  VOLUME_REBATE_ADJUSTED_SUCCESSFULLY: 'Volume rebate ajustado correctamente.',
  VOLUME_REBATE_ADJUSTMENT_NOT_NEGATIVE: 'Debe ser mayor o igual a $0',
}
